
export function isOnline() {
    return navigator.onLine;
}